import { mergeStyleSets } from '@fluentui/react';
import styled from 'styled-components';

export const modalStyles = mergeStyleSets({
  container: {
    display: 'flex',
    borderRadius: 16,
    width: 650,
    padding: '32px 16px',
    boxShadow: 'inset 0 6px 0 0 #FD6262, 1px 1px 8px rgba(0, 0, 0, 0.05)',
  },
});

export const OpenProjectModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  #createProject {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    width: fit-content;
    border: 1px solid ${({ theme }: {theme: any}) => theme.themePrimary};
    background: transparent;
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
    font: 700 1rem/1rem 'Roboto', sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${({ theme }: {theme: any}) => theme.themePrimary};
      color: #fff;
    }
  }
`;

export const OpenProjectModalHeader = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  padding: 0 20px 20px;
  align-items: center;

  h1 {
    font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
    white-space: nowrap;
  }

  h2 {
    border-left: 1px solid #dfdfdf;
    padding-left: 12px;
    font: 400 0.9rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }

  .closeModal {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
`;

export const OpenProjectModalFooter = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span {
    font: 700 0.7rem/1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.themeDark};
  }

  input {
    padding: 0 1rem;
    font: 300 0.8rem/1rem 'Roboto', sans-serif;
    height: 100%;
    border: 1px solid hsl(0, 0%, 80%);
    border-radius: 5px;

    &::placeholder {
      color: hsl(0, 0%, 60%);
    }
  }
`;

export const ProjectList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  p {
    margin: 1.5rem 0;
    width: 100%;
    text-align: center;
    font: 500 1.1rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralTertiary};
  }
`;

export const ProjectItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 2rem;
  border-radius: 1rem;
  background-color: ${({ theme }: {theme: any}) => theme.neutralLight};
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  .content {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    p {
      font: 400 0.9rem/1.1rem 'Roboto', sans-serif;
      max-height: 0;
      height: 100%;
      color: #ffffff;
      margin: 0;
      transition: all 0.3s ease-in-out;
    }
  }

  &:hover {
    background-color: ${({ theme }: {theme: any}) => theme.themePrimary};

    button.delete {
      visibility: visible;
      opacity: 1;
    }

    .content {
      h2 {
        color: #ffffff;
      }
      p {
        max-height: 100px;
      }
    }
  }

  h2 {
    font: 600 1rem/1.1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
    transition: all 0.3s ease-in-out;
  }

  button.delete {
    visibility: hidden;
    opacity: 0;
    color: #ffffff;
    transition: all 0.3s ease-in-out;
    background: transparent;
    border: none;
    padding: 6px;
    border-radius: 50%;
    height: 100%;
    cursor: pointer;

    &:hover {
      background: #ffffff;
      color: ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }
`;
